// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"659":"efe2bfbe","787":"7de2a594","828":"24c13c3e"}[chunkId] + ".chunk.js";
};